'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var config = {
  styling: {
    theme: []
  },
  elementID: 'cookie-banner-component',
  disablePoweredBy: true,
  storageName: 'cookie-banner-component',
  htmlTexts: true,
  hideLearnMore: true,
  additionalClass: 'cookie-banner-container',
  acceptAll: true,
  translations: {},
  services: [{
    name: 'google-tag-manager',
    purposes: ['Marketing'],
    onAccept: "\n                // we notify the tag manager about all services that were accepted. You can define\n                // a custom event in GTM to load the service if consent was given.\n                for(let k of Object.keys(opts.consents)){\n                    if (opts.consents[k]){\n                        const eventName = 'klaro-'+k+'-accepted'\n                        dataLayer.push({'event': eventName})\n                    }\n                }\n                // if consent for Google Analytics was granted we enable analytics storage\n                if (opts.consents[opts.vars.googleAnalytics || 'google-analytics']){\n                    console.log(\"Google analytics usage was granted\")\n                    gtag('consent', 'update', {'analytics_storage': 'granted'})\n                }\n                // if consent for Google Ads was granted we enable ad storage\n                // if (opts.consents[opts.vars.adStorageName || 'google-ads']){\n                //     console.log(\"Google ads usage was granted\")\n                //     gtag('consent', 'update', {'ad_storage': 'granted'})\n                // }\n            ",
    onInit: "\n                // initialization code here (will be executed only once per page-load)\n                window.dataLayer = window.dataLayer || [];\n                window.gtag = function(){dataLayer.push(arguments)}\n                gtag('consent', 'default', {'analytics_storage': 'denied'})\n                gtag('set', 'ads_data_redaction', true)\n            ",
    onDecline: "\n                // initialization code here (will be executed only once per page-load)\n                window.dataLayer = window.dataLayer || [];\n                window.gtag = function(){dataLayer.push(arguments)}\n                gtag('consent', 'default', {'analytics_storage': 'denied'})\n                gtag('set', 'ads_data_redaction', true)\n            ",
    vars: {
      googleAnalytics: 'google-analytics'
    }
  }, {
    // In GTM, you should define a custom event trigger named `klaro-google-analytics-accepted` which should
    // trigger the Google Analytics integration.
    name: 'google-analytics',
    purposes: ['Marketing'],
    cookies: [/^_ga(_.*)?/ // we delete the Google Analytics cookies if the user declines its use
    ]
  }, {
    name: 'google-maps',
    purposes: ['Functionality']
  }]
};
var _default = config;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/cookie-banner/config.js
// module id = 336
// module chunks = 0